export const languages = [
  'en',
  'es',
  'ja',
  'zhcn',
  'zhtw',
  'ru',
  'vi',
  // 'de', 'fr',
  // 'hi', 'id', 'it',
  // 'nl', 'pt', 'ru',
];



// WEBPACK FOOTER //
// ../src/constants/languages.js